/*
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file has been auto-generated. Any modifications
 * you make will be overwritten when the file is regenerated.
 *
 * For more information or questions, please go to #design-eng
 *
 */

/* Primitives color tokens
 * **DO NOT USE DIRECTLY**
 * Use semantic color tokens instead.
 */
export const primitiveColorTokens = {
  amber50: '#FFF1E1',
  amber100: '#FFE4B7',
  amber200: '#FFD5A1',
  amber300: '#FFB749',
  amber400: '#DF9500',
  amber500: '#C46E00',
  amber600: '#A95F03',
  amber700: '#904A07',
  amber800: '#763A00',
  amber900: '#3E2000',
  black: '#000000',
  blue50: '#EFF4FE',
  blue100: '#DEE9FE',
  blue200: '#CDDEFF',
  blue300: '#A9C9FF',
  blue400: '#6DAAFB',
  blue500: '#068BEE',
  blue600: '#276EF1',
  blue700: '#175BCC',
  blue800: '#1948A3',
  blue900: '#002661',
  brandAi0: '#000000',
  brandAi15: '#14011E',
  brandAi18: '#1E002D',
  brandAi23: '#2B0241',
  brandAi27: '#390059',
  brandAi31: '#45066C',
  brandAi35: '#520484',
  brandAi40: '#5F0D9C',
  brandAi44: '#6B11B4',
  brandAi48: '#7B00D5',
  brandAi53: '#8815EB',
  brandAi57: '#932FFB',
  brandAi61: '#9C4EFD',
  brandAi66: '#A469FB',
  brandAi70: '#AE7FFB',
  brandAi74: '#B891FC',
  brandAi79: '#C3A4FC',
  brandAi83: '#CEB5FD',
  brandAi87: '#DAC7FF',
  brandAi91: '#E6D8FF',
  brandAi96: '#F0E8FF',
  brandAi98: '#F8F4FF',
  brandAi99: '#FDFCFF',
  brandAi100: '#FFFFFF',
  brandAiGradient0: '#260781',
  brandAiGradient15: '#2C068A',
  brandAiGradient18: '#330393',
  brandAiGradient23: '#380B97',
  brandAiGradient27: '#3F08A0',
  brandAiGradient31: '#4603A9',
  brandAiGradient35: '#4C0CAD',
  brandAiGradient40: '#5305B6',
  brandAiGradient44: '#5A0FBA',
  brandAiGradient48: '#6207C3',
  brandAiGradient53: '#6A12C7',
  brandAiGradient57: '#7308D0',
  brandAiGradient61: '#7B13D4',
  brandAiGradient66: '#841BD7',
  brandAiGradient70: '#8E22DA',
  brandAiGradient74: '#9728DC',
  brandAiGradient79: '#A22EDF',
  brandAiGradient83: '#AC33E1',
  brandAiGradient87: '#B739E3',
  brandAiGradient91: '#C23EE4',
  brandAiGradient96: '#CD43E5',
  brandAiGradient98: '#D847E6',
  brandAiGradient99: '#E24CE7',
  brandAiGradient100: '#ED51E8',
  brandDefault50: '#EFF4FE',
  brandDefault100: '#DEE9FE',
  brandDefault200: '#CDDEFF',
  brandDefault300: '#A9C9FF',
  brandDefault400: '#6DAAFB',
  brandDefault500: '#068BEE',
  brandDefault600: '#276EF1',
  brandDefault700: '#175BCC',
  brandDefault800: '#1948A3',
  brandDefault900: '#002661',
  brandDefaultGradient0: '#0D012A',
  brandDefaultGradient15: '#130041',
  brandDefaultGradient20: '#170158',
  brandDefaultGradient25: '#1A0073',
  brandDefaultGradient30: '#18048D',
  brandDefaultGradient35: '#1304AA',
  brandDefaultGradient40: '#0510C3',
  brandDefaultGradient45: '#023BB8',
  brandDefaultGradient50: '#0249C5',
  brandDefaultGradient57: '#0253D8',
  brandDefaultGradient66: '#0D5EEC',
  brandDefaultGradient74: '#246AF9',
  brandDefaultGradient82: '#4178FB',
  brandDefaultGradient90: '#5A85FD',
  brandDefaultGradient94: '#7492FB',
  brandDefaultGradient97: '#8A9EFE',
  brandDefaultGradient99: '#A0A9FE',
  brandDefaultGradient100: '#B5B5FF',
  brandEats50: '#EAF6ED',
  brandEats100: '#D3EFDA',
  brandEats200: '#B1EAC2',
  brandEats300: '#7FD99A',
  brandEats400: '#06C167',
  brandEats500: '#009A51',
  brandEats600: '#0E8345',
  brandEats700: '#166C3B',
  brandEats800: '#0D572D',
  brandEats900: '#002F14',
  brandMembershipGradient0: '#C3A86E',
  brandMembershipGradient15: '#C8AD72',
  brandMembershipGradient20: '#CDB277',
  brandMembershipGradient25: '#D2B77C',
  brandMembershipGradient30: '#D7BB80',
  brandMembershipGradient35: '#DCC085',
  brandMembershipGradient40: '#E1C58A',
  brandMembershipGradient45: '#E6CA8F',
  brandMembershipGradient50: '#EBCF93',
  brandMembershipGradient57: '#F0D498',
  brandMembershipGradient66: '#F5D99D',
  brandMembershipGradient74: '#FADEA2',
  brandMembershipGradient82: '#FFE3A6',
  brandMembershipGradient90: '#FEE9BB',
  brandMembershipGradient94: '#FEEECD',
  brandMembershipGradient97: '#FFF4DE',
  brandMembershipGradient99: '#FFFAEE',
  brandMembershipGradient100: '#FFFFFF',
  brandMembershipPrimary0: '#000000',
  brandMembershipPrimary15: '#181001',
  brandMembershipPrimary20: '#261A01',
  brandMembershipPrimary25: '#332401',
  brandMembershipPrimary30: '#3E2E03',
  brandMembershipPrimary35: '#4C3802',
  brandMembershipPrimary40: '#5A4305',
  brandMembershipPrimary45: '#664E0F',
  brandMembershipPrimary50: '#745B20',
  brandMembershipPrimary57: '#8D733A',
  brandMembershipPrimary66: '#A78D53',
  brandMembershipPrimary74: '#C3A86E',
  brandMembershipPrimary82: '#DFC488',
  brandMembershipPrimary90: '#FBE0A3',
  brandMembershipPrimary94: '#FFEFCD',
  brandMembershipPrimary97: '#FFF9ED',
  brandMembershipPrimary99: '#FFFCF5',
  brandMembershipPrimary100: '#FFFFFF',
  brandOffers0: '#000000',
  brandOffers15: '#1D0000',
  brandOffers18: '#2A0000',
  brandOffers23: '#3C0201',
  brandOffers27: '#4F0402',
  brandOffers31: '#610302',
  brandOffers35: '#730805',
  brandOffers40: '#890302',
  brandOffers44: '#9D0301',
  brandOffers48: '#AE1009',
  brandOffers53: '#C20503',
  brandOffers57: '#D4110B',
  brandOffers61: '#EC0000',
  brandOffers66: '#FD281D',
  brandOffers70: '#FC5D4B',
  brandOffers74: '#FE7D6C',
  brandOffers79: '#FF998A',
  brandOffers83: '#FDB1A4',
  brandOffers87: '#FEC5BB',
  brandOffers91: '#FED9D3',
  brandOffers96: '#FFECE8',
  brandOffers98: '#FFF8F7',
  brandOffers99: '#FFFBFA',
  brandOffers100: '#FFFFFF',
  brandOffersGradient0: '#7A0540',
  brandOffersGradient15: '#820342',
  brandOffersGradient18: '#880C44',
  brandOffersGradient23: '#900945',
  brandOffersGradient27: '#990446',
  brandOffersGradient31: '#9E0E46',
  brandOffersGradient35: '#A80944',
  brandOffersGradient40: '#B10240',
  brandOffersGradient44: '#B8103C',
  brandOffersGradient48: '#C20C34',
  brandOffersGradient53: '#CD062A',
  brandOffersGradient57: '#D31923',
  brandOffersGradient61: '#DE1812',
  brandOffersGradient66: '#E62708',
  brandOffersGradient70: '#E93C15',
  brandOffersGradient74: '#F14612',
  brandOffersGradient79: '#F95011',
  brandOffersGradient83: '#FD6023',
  brandOffersGradient87: '#FD713A',
  brandOffersGradient91: '#FE814D',
  brandOffersGradient96: '#FE8F5D',
  brandOffersGradient98: '#FD9E71',
  brandOffersGradient99: '#FFAA7F',
  brandOffersGradient100: '#FEB68F',
  gray50: '#F3F3F3',
  gray100: '#E8E8E8',
  gray200: '#DDDDDD',
  gray300: '#BBBBBB',
  gray400: '#A6A6A6',
  gray500: '#868686',
  gray600: '#727272',
  gray700: '#5E5E5E',
  gray800: '#4B4B4B',
  gray900: '#282828',
  green50: '#EAF6ED',
  green100: '#D3EFDA',
  green200: '#B1EAC2',
  green300: '#7FD99A',
  green400: '#06C167',
  green500: '#009A51',
  green600: '#0E8345',
  green700: '#166C3B',
  green800: '#0D572D',
  green900: '#002F14',
  lime50: '#EEF6E3',
  lime100: '#DEEEC6',
  lime200: '#CAE6A0',
  lime300: '#A6D467',
  lime400: '#77B71C',
  lime500: '#5B9500',
  lime600: '#4F7F06',
  lime700: '#3F6900',
  lime800: '#365310',
  lime900: '#1B2D00',
  magenta50: '#FEEFF9',
  magenta100: '#FEDFF3',
  magenta200: '#FFCEF2',
  magenta300: '#FFACE5',
  magenta400: '#F877D2',
  magenta500: '#E142BC',
  magenta600: '#CA26A5',
  magenta700: '#A91A90',
  magenta800: '#891869',
  magenta900: '#50003F',
  orange50: '#FFF0E9',
  orange100: '#FEE2D4',
  orange200: '#FFD3BC',
  orange300: '#FFB48C',
  orange400: '#FC823A',
  orange500: '#E65300',
  orange600: '#C54600',
  orange700: '#A33B04',
  orange800: '#823006',
  orange900: '#461A00',
  periwinkle50: '#F2F4FF',
  periwinkle100: '#E4E8FF',
  periwinkle200: '#D5DCFF',
  periwinkle300: '#BCC6FF',
  periwinkle400: '#96A2FF',
  periwinkle500: '#6C72FB',
  periwinkle600: '#5B53FE',
  periwinkle700: '#4D4AD4',
  periwinkle800: '#3C3F97',
  periwinkle900: '#202252',
  purple50: '#F9F1FF',
  purple100: '#F2E3FF',
  purple200: '#EBD5FF',
  purple300: '#DDB9FF',
  purple400: '#C490F9',
  purple500: '#A964F7',
  purple600: '#944DE7',
  purple700: '#7C3EC3',
  purple800: '#633495',
  purple900: '#3A1659',
  red50: '#FFF0EE',
  red100: '#FFE1DE',
  red200: '#FFD2CD',
  red300: '#FFB2AB',
  red400: '#FC7F79',
  red500: '#F83446',
  red600: '#DE1135',
  red700: '#BB032A',
  red800: '#950F22',
  red900: '#520810',
  teal50: '#E2F8FB',
  teal100: '#CDEEF3',
  teal200: '#B0E7EF',
  teal300: '#77D5E3',
  teal400: '#01B8CA',
  teal500: '#0095A4',
  teal600: '#007F8C',
  teal700: '#016974',
  teal800: '#1A535A',
  teal900: '#002D33',
  white: '#FFFFFF',
  yellow50: '#FDF2DC',
  yellow100: '#FBE5B6',
  yellow200: '#FFD688',
  yellow300: '#F6BC2F',
  yellow400: '#D79900',
  yellow500: '#B97502',
  yellow600: '#9F6402',
  yellow700: '#845201',
  yellow800: '#6B4100',
  yellow900: '#392300',
  amber50Dark: '#241004',
  amber100Dark: '#3C220F',
  amber200Dark: '#502F17',
  amber300Dark: '#663C1C',
  amber400Dark: '#864D23',
  amber500Dark: '#A25E2B',
  amber600Dark: '#C07A2D',
  amber700Dark: '#E2A64F',
  amber800Dark: '#F0C284',
  amber900Dark: '#F5DAB7',
  blue50Dark: '#09152C',
  blue100Dark: '#182946',
  blue200Dark: '#22375C',
  blue300Dark: '#2D4775',
  blue400Dark: '#335BA3',
  blue500Dark: '#3F6EC5',
  blue600Dark: '#5E8BDB',
  blue700Dark: '#93B4EE',
  blue800Dark: '#B3CCF6',
  blue900Dark: '#D1DFF6',
  brandDefault50Dark: '#09152C',
  brandDefault100Dark: '#182946',
  brandDefault200Dark: '#22375C',
  brandDefault300Dark: '#2D4775',
  brandDefault400Dark: '#335BA3',
  brandDefault500Dark: '#3F6EC5',
  brandDefault600Dark: '#5E8BDB',
  brandDefault700Dark: '#93B4EE',
  brandDefault800Dark: '#B3CCF6',
  brandDefault900Dark: '#D1DFF6',
  brandEats50Dark: '#081B0E',
  brandEats100Dark: '#162F1E',
  brandEats200Dark: '#20402A',
  brandEats300Dark: '#2A5237',
  brandEats400Dark: '#306C44',
  brandEats500Dark: '#3D8351',
  brandEats600Dark: '#5C9D70',
  brandEats700Dark: '#8FC19C',
  brandEats800Dark: '#AED6B8',
  brandEats900Dark: '#CBE6D2',
  gray50Dark: '#161616',
  gray100Dark: '#292929',
  gray200Dark: '#383838',
  gray300Dark: '#484848',
  gray400Dark: '#5D5D5D',
  gray500Dark: '#717171',
  gray600Dark: '#8C8C8C',
  gray700Dark: '#ABABAB',
  gray800Dark: '#C4C4C4',
  gray900Dark: '#DEDEDE',
  green50Dark: '#081B0E',
  green100Dark: '#162F1E',
  green200Dark: '#20402A',
  green300Dark: '#2A5237',
  green400Dark: '#306C44',
  green500Dark: '#3D8351',
  green600Dark: '#5C9D70',
  green700Dark: '#8FC19C',
  green800Dark: '#AED6B8',
  green900Dark: '#CBE6D2',
  lime50Dark: '#111908',
  lime100Dark: '#202E13',
  lime200Dark: '#2C3F19',
  lime300Dark: '#39501F',
  lime400Dark: '#4A682B',
  lime500Dark: '#5A7E35',
  lime600Dark: '#759954',
  lime700Dark: '#9EC080',
  lime800Dark: '#BBD5A5',
  lime900Dark: '#D6E3CB',
  magenta50Dark: '#28071F',
  magenta100Dark: '#411636',
  magenta200Dark: '#581F48',
  magenta300Dark: '#6E2A5B',
  magenta400Dark: '#8E3777',
  magenta500Dark: '#AB4490',
  magenta600Dark: '#C664A9',
  magenta700Dark: '#E496CB',
  magenta800Dark: '#EEB6DB',
  magenta900Dark: '#F1D4E7',
  orange50Dark: '#231107',
  orange100Dark: '#3D2112',
  orange200Dark: '#532C18',
  orange300Dark: '#6D3715',
  orange400Dark: '#8C4922',
  orange500Dark: '#AB5727',
  orange600Dark: '#CD6F3D',
  orange700Dark: '#ED9E74',
  orange800Dark: '#F1BDA3',
  orange900Dark: '#F8D6C5',
  periwinkle50Dark: '#11132C',
  periwinkle100Dark: '#222646',
  periwinkle200Dark: '#2F335C',
  periwinkle300Dark: '#3C417A',
  periwinkle400Dark: '#4D54A2',
  periwinkle500Dark: '#5E66C4',
  periwinkle600Dark: '#7883DD',
  periwinkle700Dark: '#A4AEEE',
  periwinkle800Dark: '#BFC8F6',
  periwinkle900Dark: '#D8DDF6',
  purple50Dark: '#1A1029',
  purple100Dark: '#2F2044',
  purple200Dark: '#3F2D59',
  purple300Dark: '#513974',
  purple400Dark: '#694B96',
  purple500Dark: '#7F5BB6',
  purple600Dark: '#9A78CE',
  purple700Dark: '#BDA7E4',
  purple800Dark: '#D2C1EF',
  purple900Dark: '#E3D8F8',
  red50Dark: '#2C0809',
  red100Dark: '#471618',
  red200Dark: '#621C20',
  red300Dark: '#7F1F26',
  red400Dark: '#A32C34',
  red500Dark: '#C33840',
  red600Dark: '#DE5B5D',
  red700Dark: '#EA9B98',
  red800Dark: '#EFBCB9',
  red900Dark: '#F2D7D5',
  teal50Dark: '#0B191B',
  teal100Dark: '#0C2E34',
  teal200Dark: '#113F46',
  teal300Dark: '#155158',
  teal400Dark: '#216972',
  teal500Dark: '#217F8B',
  teal600Dark: '#3B9BA8',
  teal700Dark: '#61C4D2',
  teal800Dark: '#8AD9E6',
  teal900Dark: '#C5E5EA',
  yellow50Dark: '#201304',
  yellow100Dark: '#39240A',
  yellow200Dark: '#4A3316',
  yellow300Dark: '#614013',
  yellow400Dark: '#7E541B',
  yellow500Dark: '#9A6418',
  yellow600Dark: '#BC7D26',
  yellow700Dark: '#DBAB4C',
  yellow800Dark: '#EDC56E',
  yellow900Dark: '#F4DCAA'
};
interface PrimitiveColorTokensType {
  [key: string]: string;
}

/*
 *  Semantic color tokens, light mode
 */
export const semanticColorTokensLight = (primitiveColorTokens: PrimitiveColorTokensType) => ({
  backgroundPrimary: primitiveColorTokens.white,
  backgroundSecondary: primitiveColorTokens.gray50,
  backgroundTertiary: primitiveColorTokens.gray100,
  contentPrimary: primitiveColorTokens.black,
  contentSecondary: primitiveColorTokens.gray800,
  contentTertiary: primitiveColorTokens.gray700,
  borderOpaque: primitiveColorTokens.gray50,
  borderTransparent: 'rgba(0, 0, 0, 0.08)',
  borderSelected: primitiveColorTokens.black,
  borderAccessible: primitiveColorTokens.gray500,
  backgroundInversePrimary: primitiveColorTokens.black,
  backgroundInverseSecondary: primitiveColorTokens.gray900,
  contentInversePrimary: primitiveColorTokens.white,
  contentInverseSecondary: primitiveColorTokens.gray200,
  contentInverseTertiary: primitiveColorTokens.gray400,
  borderInverseOpaque: primitiveColorTokens.gray800,
  borderInverseTransparent: 'rgba(255, 255, 255, 0.2)',
  borderInverseSelected: primitiveColorTokens.white,
  brandBackgroundPrimary: primitiveColorTokens.brandDefault600,
  brandBackgroundSecondary: primitiveColorTokens.brandDefault50,
  brandBackgroundTertiary: primitiveColorTokens.white,
  brandBackgroundDisabled: primitiveColorTokens.brandDefault50,
  brandContentPrimary: primitiveColorTokens.brandDefault600,
  brandContentOnPrimary: primitiveColorTokens.white,
  brandContentOnSecondary: primitiveColorTokens.brandDefault700,
  brandContentOnTertiary: primitiveColorTokens.black,
  brandContentOnGradient: primitiveColorTokens.white,
  brandContentDisabled: primitiveColorTokens.brandDefault300,
  brandBorderAccessible: primitiveColorTokens.brandDefault600,
  brandBorderSubtle: primitiveColorTokens.brandDefault100,
  brandGradientStop1: primitiveColorTokens.brandDefaultGradient35,
  brandGradientStop2: primitiveColorTokens.brandDefaultGradient50,
  backgroundStateDisabled: primitiveColorTokens.gray50,
  brandGradientStop3: primitiveColorTokens.brandDefaultGradient74,
  backgroundAccent: primitiveColorTokens.blue600,
  backgroundNegative: primitiveColorTokens.red600,
  backgroundWarning: primitiveColorTokens.yellow300,
  backgroundPositive: primitiveColorTokens.green600,
  backgroundAccentLight: primitiveColorTokens.blue50,
  backgroundNegativeLight: primitiveColorTokens.red50,
  backgroundWarningLight: primitiveColorTokens.yellow50,
  backgroundPositiveLight: primitiveColorTokens.green50,
  backgroundAlwaysDark: primitiveColorTokens.black,
  backgroundAlwaysLight: primitiveColorTokens.white,
  backgroundOverlayArt: 'rgba(0, 0, 0, 0)',
  backgroundOverlayDark: 'rgba(0, 0, 0, 0.5)',
  backgroundOverlayLight: 'rgba(0, 0, 0, 0.8)',
  backgroundOverlayElevation: 'rgba(255, 255, 255, 0)',
  backgroundOverlay: 'rgba(0, 0, 0, 0.15)',
  contentStateDisabled: primitiveColorTokens.gray400,
  contentOnColor: primitiveColorTokens.white,
  contentOnColorInverse: primitiveColorTokens.black,
  contentAccent: primitiveColorTokens.blue600,
  contentNegative: primitiveColorTokens.red600,
  contentWarning: primitiveColorTokens.yellow600,
  contentPositive: primitiveColorTokens.green600,
  borderStateDisabled: primitiveColorTokens.gray50,
  borderAccent: primitiveColorTokens.blue600,
  borderNegative: primitiveColorTokens.red600,
  borderWarning: primitiveColorTokens.yellow600,
  borderPositive: primitiveColorTokens.green600,
  borderAccentLight: primitiveColorTokens.blue100,
  borderPositiveLight: primitiveColorTokens.green100,
  borderNegativeLight: primitiveColorTokens.red100,
  borderWarningLight: primitiveColorTokens.yellow100,
  membership: primitiveColorTokens.yellow600,
  safety: primitiveColorTokens.blue600,
  eats: primitiveColorTokens.green600,
  freight: '#0E1FC1',
  rewardsTier1: primitiveColorTokens.blue600,
  rewardsTier2: primitiveColorTokens.yellow300,
  rewardsTier3: '#8FA3AD',
  rewardsTier4: primitiveColorTokens.black,
  tagGrayBackgroundPrimary: primitiveColorTokens.gray600,
  tagGrayBackgroundSecondary: primitiveColorTokens.gray50,
  tagGrayContentPrimary: primitiveColorTokens.white,
  tagGrayContentSecondary: primitiveColorTokens.gray700,
  tagGrayBackgroundStateDisabled: primitiveColorTokens.gray50,
  tagGrayContentStateDisabled: primitiveColorTokens.gray300,
  tagGrayBorderPrimaryUnselected: primitiveColorTokens.gray700,
  tagGrayBorderSecondaryUnselected: primitiveColorTokens.gray100,
  tagGrayBorderSecondarySelected: primitiveColorTokens.gray600,
  tagRedBackgroundPrimary: primitiveColorTokens.red600,
  tagRedBackgroundSecondary: primitiveColorTokens.red50,
  tagRedContentPrimary: primitiveColorTokens.white,
  tagRedContentSecondary: primitiveColorTokens.red700,
  tagRedBackgroundStateDisabled: primitiveColorTokens.red50,
  tagRedContentStateDisabled: primitiveColorTokens.red300,
  tagRedBorderPrimaryUnselected: primitiveColorTokens.red700,
  tagRedBorderSecondaryUnselected: primitiveColorTokens.red100,
  tagRedBorderSecondarySelected: primitiveColorTokens.red700,
  tagOrangeBackgroundPrimary: primitiveColorTokens.orange600,
  tagOrangeBackgroundSecondary: primitiveColorTokens.orange50,
  tagOrangeContentPrimary: primitiveColorTokens.white,
  tagOrangeContentSecondary: primitiveColorTokens.orange700,
  tagOrangeBackgroundStateDisabled: primitiveColorTokens.orange50,
  tagOrangeContentStateDisabled: primitiveColorTokens.orange300,
  tagOrangeBorderPrimaryUnselected: primitiveColorTokens.orange700,
  tagYellowBackgroundPrimary: primitiveColorTokens.yellow300,
  tagYellowBackgroundSecondary: primitiveColorTokens.yellow50,
  tagOrangeBorderSecondaryUnselected: primitiveColorTokens.orange100,
  tagOrangeBorderSecondarySelected: primitiveColorTokens.orange700,
  tagYellowContentPrimary: primitiveColorTokens.black,
  tagYellowContentSecondary: primitiveColorTokens.yellow700,
  tagYellowBackgroundStateDisabled: primitiveColorTokens.yellow50,
  tagYellowContentStateDisabled: primitiveColorTokens.yellow200,
  tagYellowBorderPrimaryUnselected: primitiveColorTokens.yellow400,
  tagYellowBorderSecondaryUnselected: primitiveColorTokens.yellow100,
  tagYellowBorderSecondarySelected: primitiveColorTokens.yellow700,
  tagGreenBackgroundPrimary: primitiveColorTokens.green600,
  tagGreenBackgroundSecondary: primitiveColorTokens.green50,
  tagGreenContentPrimary: primitiveColorTokens.white,
  tagGreenContentSecondary: primitiveColorTokens.green700,
  tagGreenBackgroundStateDisabled: primitiveColorTokens.green50,
  tagGreenContentStateDisabled: primitiveColorTokens.green300,
  tagBlueBackgroundPrimary: primitiveColorTokens.blue600,
  tagGreenBorderPrimaryUnselected: primitiveColorTokens.green700,
  tagBlueBackgroundSecondary: primitiveColorTokens.blue50,
  tagGreenBorderSecondaryUnselected: primitiveColorTokens.green100,
  tagBlueContentPrimary: primitiveColorTokens.white,
  tagGreenBorderSecondarySelected: primitiveColorTokens.green700,
  tagBlueContentSecondary: primitiveColorTokens.blue700,
  tagBlueBackgroundStateDisabled: primitiveColorTokens.blue50,
  tagBlueContentStateDisabled: primitiveColorTokens.blue300,
  tagBlueBorderPrimaryUnselected: primitiveColorTokens.blue700,
  tagPurpleBackgroundPrimary: primitiveColorTokens.purple600,
  tagPurpleBackgroundSecondary: primitiveColorTokens.purple50,
  tagBlueBorderSecondaryUnselected: primitiveColorTokens.blue100,
  tagPurpleContentPrimary: primitiveColorTokens.white,
  tagBlueBorderSecondarySelected: primitiveColorTokens.blue700,
  tagPurpleContentSecondary: primitiveColorTokens.purple700,
  tagPurpleBackgroundStateDisabled: primitiveColorTokens.purple50,
  tagPurpleContentStateDisabled: primitiveColorTokens.purple300,
  tagPurpleBorderPrimaryUnselected: primitiveColorTokens.purple700,
  tagMagentaBackgroundPrimary: primitiveColorTokens.magenta600,
  tagMagentaBackgroundSecondary: primitiveColorTokens.magenta50,
  tagPurpleBorderSecondaryUnselected: primitiveColorTokens.purple100,
  tagMagentaContentPrimary: primitiveColorTokens.white,
  tagPurpleBorderSecondarySelected: primitiveColorTokens.purple700,
  tagMagentaContentSecondary: primitiveColorTokens.magenta700,
  tagMagentaBackgroundStateDisabled: primitiveColorTokens.magenta50,
  tagMagentaContentStateDisabled: primitiveColorTokens.magenta300,
  tagMagentaBorderPrimaryUnselected: primitiveColorTokens.magenta700,
  tagMagentaBorderSecondaryUnselected: primitiveColorTokens.magenta100,
  tagMagentaBorderSecondarySelected: primitiveColorTokens.magenta700,
  hoverOverlayInverseAlpha: 'rgba(255, 255, 255, 0.1)',
  hoverOverlayAlpha: 'rgba(0, 0, 0, 0.04)',
  hoverNegativeAlpha: 'rgba(222, 17, 53, 0.1)',
  pressedOverlayAlpha: 'rgba(0, 0, 0, 0.08)',
  pressedOverlayInverseAlpha: 'rgba(255, 255, 255, 0.2)',
  pressedNegativeAlpha: 'rgba(222, 17, 53, 0.15)',
  gradientStop1: primitiveColorTokens.gray100,
  gradientStop2: primitiveColorTokens.gray50,
  gradientStop3: primitiveColorTokens.gray100,
  tagTealBackgroundPrimary: primitiveColorTokens.teal600,
  tagTealBackgroundSecondary: primitiveColorTokens.teal50,
  tagTealContentPrimary: primitiveColorTokens.white,
  tagTealContentSecondary: primitiveColorTokens.teal700,
  tagTealBackgroundStateDisabled: primitiveColorTokens.teal50,
  tagTealContentStateDisabled: primitiveColorTokens.teal300,
  tagTealBorderPrimaryUnselected: primitiveColorTokens.teal700,
  tagTealBorderSecondaryUnselected: primitiveColorTokens.teal100,
  tagTealBorderSecondarySelected: primitiveColorTokens.teal700,
  tagLimeBackgroundPrimary: primitiveColorTokens.lime600,
  tagLimeBackgroundSecondary: primitiveColorTokens.lime50,
  tagLimeContentPrimary: primitiveColorTokens.white,
  tagLimeContentSecondary: primitiveColorTokens.lime700,
  tagLimeBackgroundStateDisabled: primitiveColorTokens.lime50,
  tagLimeContentStateDisabled: primitiveColorTokens.lime300,
  tagLimeBorderPrimaryUnselected: primitiveColorTokens.lime700,
  tagLimeBorderSecondaryUnselected: primitiveColorTokens.lime100,
  tagLimeBorderSecondarySelected: primitiveColorTokens.lime700,
  tagPeriwinkleBackgroundPrimary: primitiveColorTokens.periwinkle600,
  tagPeriwinkleBackgroundSecondary: primitiveColorTokens.periwinkle50,
  tagPeriwinkleContentPrimary: primitiveColorTokens.white,
  tagPeriwinkleContentSecondary: primitiveColorTokens.periwinkle700,
  tagPeriwinkleBackgroundStateDisabled: primitiveColorTokens.periwinkle50,
  tagPeriwinkleContentStateDisabled: primitiveColorTokens.periwinkle300,
  tagPeriwinkleBorderPrimaryUnselected: primitiveColorTokens.periwinkle700,
  tagPeriwinkleBorderSecondaryUnselected: primitiveColorTokens.periwinkle100,
  tagPeriwinkleBorderSecondarySelected: primitiveColorTokens.periwinkle700
});

/*
 *  Semantic color tokens, dark mode
 */
export const semanticColorTokensDark = (primitiveColorTokens: PrimitiveColorTokensType) => ({
  backgroundPrimary: primitiveColorTokens.gray50Dark,
  backgroundSecondary: primitiveColorTokens.gray100Dark,
  backgroundTertiary: primitiveColorTokens.gray200Dark,
  contentPrimary: primitiveColorTokens.gray900Dark,
  contentSecondary: primitiveColorTokens.gray800Dark,
  contentTertiary: primitiveColorTokens.gray700Dark,
  borderOpaque: primitiveColorTokens.gray100Dark,
  borderTransparent: 'rgba(222, 222, 222, 0.08)',
  borderSelected: primitiveColorTokens.gray900Dark,
  borderAccessible: primitiveColorTokens.gray600,
  backgroundInversePrimary: primitiveColorTokens.gray800Dark,
  backgroundInverseSecondary: primitiveColorTokens.gray700Dark,
  contentInversePrimary: primitiveColorTokens.black,
  contentInverseSecondary: primitiveColorTokens.gray200Dark,
  contentInverseTertiary: primitiveColorTokens.gray300Dark,
  borderInverseOpaque: primitiveColorTokens.gray300Dark,
  borderInverseTransparent: 'rgba(22, 22, 22, 0.2)',
  borderInverseSelected: primitiveColorTokens.gray50Dark,
  brandBackgroundPrimary: primitiveColorTokens.brandDefault500Dark,
  brandBackgroundSecondary: primitiveColorTokens.brandDefault100Dark,
  brandBackgroundTertiary: primitiveColorTokens.white,
  brandBackgroundDisabled: primitiveColorTokens.brandDefault100Dark,
  brandContentPrimary: primitiveColorTokens.brandDefault600Dark,
  brandContentOnPrimary: primitiveColorTokens.white,
  brandContentOnSecondary: primitiveColorTokens.brandDefault700Dark,
  brandContentOnTertiary: primitiveColorTokens.black,
  brandContentOnGradient: primitiveColorTokens.white,
  brandContentDisabled: primitiveColorTokens.brandDefault400Dark,
  brandBorderAccessible: primitiveColorTokens.brandDefault600Dark,
  brandBorderSubtle: primitiveColorTokens.brandDefault400Dark,
  brandGradientStop1: primitiveColorTokens.brandDefaultGradient35,
  brandGradientStop2: primitiveColorTokens.brandDefaultGradient50,
  backgroundStateDisabled: primitiveColorTokens.gray100Dark,
  brandGradientStop3: primitiveColorTokens.brandDefaultGradient74,
  backgroundAccent: primitiveColorTokens.blue400Dark,
  backgroundNegative: primitiveColorTokens.red400Dark,
  backgroundWarning: primitiveColorTokens.yellow400Dark,
  backgroundPositive: primitiveColorTokens.green400Dark,
  backgroundAccentLight: primitiveColorTokens.blue100Dark,
  backgroundNegativeLight: primitiveColorTokens.red100Dark,
  backgroundWarningLight: primitiveColorTokens.yellow100Dark,
  backgroundPositiveLight: primitiveColorTokens.green100Dark,
  backgroundAlwaysDark: primitiveColorTokens.gray100Dark,
  backgroundAlwaysLight: primitiveColorTokens.gray900Dark,
  backgroundOverlayArt: 'rgba(0, 0, 0, 0.16)',
  backgroundOverlayDark: 'rgba(0, 0, 0, 0.7)',
  backgroundOverlayLight: 'rgba(0, 0, 0, 0.8)',
  backgroundOverlayElevation: 'rgba(255, 255, 255, 0.16)',
  backgroundOverlay: 'rgba(0, 0, 0, 0.7)',
  contentStateDisabled: primitiveColorTokens.gray400Dark,
  contentOnColor: primitiveColorTokens.gray900Dark,
  contentOnColorInverse: primitiveColorTokens.black,
  contentAccent: primitiveColorTokens.blue600Dark,
  contentNegative: primitiveColorTokens.red600Dark,
  contentWarning: primitiveColorTokens.yellow600Dark,
  contentPositive: primitiveColorTokens.green600Dark,
  borderStateDisabled: primitiveColorTokens.gray100Dark,
  borderAccent: primitiveColorTokens.blue400Dark,
  borderNegative: primitiveColorTokens.red400Dark,
  borderWarning: primitiveColorTokens.yellow400Dark,
  borderPositive: primitiveColorTokens.green400Dark,
  borderAccentLight: primitiveColorTokens.blue200Dark,
  borderPositiveLight: primitiveColorTokens.green200Dark,
  borderNegativeLight: primitiveColorTokens.red200Dark,
  borderWarningLight: primitiveColorTokens.yellow200Dark,
  membership: primitiveColorTokens.yellow600,
  safety: primitiveColorTokens.blue600,
  eats: primitiveColorTokens.green600,
  freight: '#0E1FC1',
  rewardsTier1: primitiveColorTokens.blue600,
  rewardsTier2: primitiveColorTokens.yellow300,
  rewardsTier3: '#8FA3AD',
  rewardsTier4: primitiveColorTokens.black,
  tagGrayBackgroundPrimary: primitiveColorTokens.gray400Dark,
  tagGrayBackgroundSecondary: primitiveColorTokens.gray100Dark,
  tagGrayContentPrimary: primitiveColorTokens.gray900Dark,
  tagGrayContentSecondary: primitiveColorTokens.gray700Dark,
  tagGrayBackgroundStateDisabled: primitiveColorTokens.gray100Dark,
  tagGrayContentStateDisabled: primitiveColorTokens.gray400Dark,
  tagGrayBorderPrimaryUnselected: primitiveColorTokens.gray500Dark,
  tagGrayBorderSecondaryUnselected: primitiveColorTokens.gray500Dark,
  tagGrayBorderSecondarySelected: primitiveColorTokens.gray800Dark,
  tagRedBackgroundPrimary: primitiveColorTokens.red400Dark,
  tagRedBackgroundSecondary: primitiveColorTokens.red100Dark,
  tagRedContentPrimary: primitiveColorTokens.red900Dark,
  tagRedContentSecondary: primitiveColorTokens.red700Dark,
  tagRedBackgroundStateDisabled: primitiveColorTokens.red100Dark,
  tagRedContentStateDisabled: primitiveColorTokens.red400Dark,
  tagRedBorderPrimaryUnselected: primitiveColorTokens.red500Dark,
  tagRedBorderSecondaryUnselected: primitiveColorTokens.red500Dark,
  tagRedBorderSecondarySelected: primitiveColorTokens.red800Dark,
  tagOrangeBackgroundPrimary: primitiveColorTokens.orange400Dark,
  tagOrangeBackgroundSecondary: primitiveColorTokens.orange100Dark,
  tagOrangeContentPrimary: primitiveColorTokens.orange900Dark,
  tagOrangeContentSecondary: primitiveColorTokens.orange700Dark,
  tagOrangeBackgroundStateDisabled: primitiveColorTokens.orange100Dark,
  tagOrangeContentStateDisabled: primitiveColorTokens.orange400Dark,
  tagOrangeBorderPrimaryUnselected: primitiveColorTokens.orange500Dark,
  tagYellowBackgroundPrimary: primitiveColorTokens.yellow700Dark,
  tagYellowBackgroundSecondary: primitiveColorTokens.yellow100Dark,
  tagOrangeBorderSecondaryUnselected: primitiveColorTokens.orange500Dark,
  tagOrangeBorderSecondarySelected: primitiveColorTokens.orange800Dark,
  tagYellowContentPrimary: primitiveColorTokens.yellow50Dark,
  tagYellowContentSecondary: primitiveColorTokens.yellow900Dark,
  tagYellowBackgroundStateDisabled: primitiveColorTokens.yellow100Dark,
  tagYellowContentStateDisabled: primitiveColorTokens.yellow400Dark,
  tagYellowBorderPrimaryUnselected: primitiveColorTokens.yellow800Dark,
  tagYellowBorderSecondaryUnselected: primitiveColorTokens.yellow500Dark,
  tagYellowBorderSecondarySelected: primitiveColorTokens.yellow800Dark,
  tagGreenBackgroundPrimary: primitiveColorTokens.green400Dark,
  tagGreenBackgroundSecondary: primitiveColorTokens.green100Dark,
  tagGreenContentPrimary: primitiveColorTokens.green900Dark,
  tagGreenContentSecondary: primitiveColorTokens.green700Dark,
  tagGreenBackgroundStateDisabled: primitiveColorTokens.green100Dark,
  tagGreenContentStateDisabled: primitiveColorTokens.green400Dark,
  tagBlueBackgroundPrimary: primitiveColorTokens.blue400Dark,
  tagGreenBorderPrimaryUnselected: primitiveColorTokens.green500Dark,
  tagBlueBackgroundSecondary: primitiveColorTokens.blue100Dark,
  tagGreenBorderSecondaryUnselected: primitiveColorTokens.green500Dark,
  tagBlueContentPrimary: primitiveColorTokens.blue900Dark,
  tagGreenBorderSecondarySelected: primitiveColorTokens.green800Dark,
  tagBlueContentSecondary: primitiveColorTokens.blue700Dark,
  tagBlueBackgroundStateDisabled: primitiveColorTokens.blue100Dark,
  tagBlueContentStateDisabled: primitiveColorTokens.blue400Dark,
  tagBlueBorderPrimaryUnselected: primitiveColorTokens.blue500Dark,
  tagPurpleBackgroundPrimary: primitiveColorTokens.purple400Dark,
  tagPurpleBackgroundSecondary: primitiveColorTokens.purple100Dark,
  tagBlueBorderSecondaryUnselected: primitiveColorTokens.blue500Dark,
  tagPurpleContentPrimary: primitiveColorTokens.purple900Dark,
  tagBlueBorderSecondarySelected: primitiveColorTokens.blue800Dark,
  tagPurpleContentSecondary: primitiveColorTokens.purple700Dark,
  tagPurpleBackgroundStateDisabled: primitiveColorTokens.purple100Dark,
  tagPurpleContentStateDisabled: primitiveColorTokens.purple400Dark,
  tagPurpleBorderPrimaryUnselected: primitiveColorTokens.purple500Dark,
  tagMagentaBackgroundPrimary: primitiveColorTokens.magenta400Dark,
  tagMagentaBackgroundSecondary: primitiveColorTokens.magenta100Dark,
  tagPurpleBorderSecondaryUnselected: primitiveColorTokens.purple500Dark,
  tagMagentaContentPrimary: primitiveColorTokens.magenta900Dark,
  tagPurpleBorderSecondarySelected: primitiveColorTokens.purple800Dark,
  tagMagentaContentSecondary: primitiveColorTokens.magenta700Dark,
  tagMagentaBackgroundStateDisabled: primitiveColorTokens.magenta100Dark,
  tagMagentaContentStateDisabled: primitiveColorTokens.magenta400Dark,
  tagMagentaBorderPrimaryUnselected: primitiveColorTokens.magenta500Dark,
  tagMagentaBorderSecondaryUnselected: primitiveColorTokens.magenta500Dark,
  tagMagentaBorderSecondarySelected: primitiveColorTokens.magenta800Dark,
  hoverOverlayInverseAlpha: 'rgba(0, 0, 0, 0.04)',
  hoverOverlayAlpha: 'rgba(255, 255, 255, 0.1)',
  hoverNegativeAlpha: 'rgba(163, 44, 52, 0.4)',
  pressedOverlayAlpha: 'rgba(255, 255, 255, 0.15)',
  pressedOverlayInverseAlpha: 'rgba(0, 0, 0, 0.08)',
  pressedNegativeAlpha: 'rgba(163, 44, 52, 0.6)',
  gradientStop1: primitiveColorTokens.gray100Dark,
  gradientStop2: primitiveColorTokens.gray200Dark,
  gradientStop3: primitiveColorTokens.gray100Dark,
  tagTealBackgroundPrimary: primitiveColorTokens.teal400Dark,
  tagTealBackgroundSecondary: primitiveColorTokens.teal100Dark,
  tagTealContentPrimary: primitiveColorTokens.teal900Dark,
  tagTealContentSecondary: primitiveColorTokens.teal700Dark,
  tagTealBackgroundStateDisabled: primitiveColorTokens.teal100Dark,
  tagTealContentStateDisabled: primitiveColorTokens.teal400Dark,
  tagTealBorderPrimaryUnselected: primitiveColorTokens.teal500Dark,
  tagTealBorderSecondaryUnselected: primitiveColorTokens.teal500Dark,
  tagTealBorderSecondarySelected: primitiveColorTokens.teal800Dark,
  tagLimeBackgroundPrimary: primitiveColorTokens.lime400Dark,
  tagLimeBackgroundSecondary: primitiveColorTokens.lime100Dark,
  tagLimeContentPrimary: primitiveColorTokens.lime900Dark,
  tagLimeContentSecondary: primitiveColorTokens.lime700Dark,
  tagLimeBackgroundStateDisabled: primitiveColorTokens.lime100Dark,
  tagLimeContentStateDisabled: primitiveColorTokens.lime400Dark,
  tagLimeBorderPrimaryUnselected: primitiveColorTokens.lime500Dark,
  tagLimeBorderSecondaryUnselected: primitiveColorTokens.lime500Dark,
  tagLimeBorderSecondarySelected: primitiveColorTokens.lime800Dark,
  tagPeriwinkleBackgroundPrimary: primitiveColorTokens.purple400Dark,
  tagPeriwinkleBackgroundSecondary: primitiveColorTokens.purple100Dark,
  tagPeriwinkleContentPrimary: primitiveColorTokens.periwinkle900Dark,
  tagPeriwinkleContentSecondary: primitiveColorTokens.periwinkle700Dark,
  tagPeriwinkleBackgroundStateDisabled: primitiveColorTokens.periwinkle100Dark,
  tagPeriwinkleContentStateDisabled: primitiveColorTokens.periwinkle400Dark,
  tagPeriwinkleBorderPrimaryUnselected: primitiveColorTokens.periwinkle500Dark,
  tagPeriwinkleBorderSecondaryUnselected: primitiveColorTokens.periwinkle500Dark,
  tagPeriwinkleBorderSecondarySelected: primitiveColorTokens.periwinkle800Dark
});